import { z } from "zod";
export const dataforseoSubmittedTaskSchema = z.object({
    version: z.string(),
    status_code: z.number(),
    status_message: z.string(),
    time: z.string(),
    cost: z.number(),
    tasks_count: z.number(),
    tasks_error: z.number(),
    tasks: z.array(z.object({
        id: z.string(),
        status_code: z.number(),
        status_message: z.string(),
        time: z.string(),
        cost: z.number(),
        result_count: z.number(),
        path: z.array(z.string()),
        data: z.object({
            place_id: z.string(),
            tag: z.string(),
        }),
        result: z.null(),
    })),
});
export const dataforseoTaskSchema = z.object({
    id: z.string(),
    status_code: z.number(),
    status_message: z.string(),
    time: z.string(),
    cost: z.number(),
    result_count: z.number(),
    path: z.array(z.string()),
    data: z.object({
        place_id: z.string(),
        tag: z.string(),
    }),
    result: z.null().or(z.array(z.object({
        keyword: z.string(),
        type: z.string(),
        se_domain: z.string(),
        location_code: z.number().or(z.null()),
        language_code: z.string().or(z.null()),
        check_url: z.string(),
        datetime: z.string(),
        title: z.string().or(z.null()),
        sub_title: z.string().or(z.null()),
        rating: z.null().or(z.object({
            rating_type: z.string(),
            value: z.number(),
            votes_count: z.number(),
            rating_max: z.number(),
        })),
        feature_id: z.string(),
        place_id: z.string(),
        cid: z.string(),
        reviews_count: z.number().or(z.null()),
        items_count: z.number(),
        items: z.null().or(z.array(z.object({
            type: z.string(),
            rank_group: z.number(),
            rank_absolute: z.number(),
            position: z.string(),
            xpath: z.any(),
            review_text: z.string().or(z.null()),
            original_review_text: z.string().or(z.null()),
            time_ago: z.string(),
            timestamp: z.string(),
            rating: z.object({
                rating_type: z.string(),
                value: z.number(),
                votes_count: z.number().or(z.null()),
                rating_max: z.number(),
            }),
            reviews_count: z.number().or(z.null()),
            photos_count: z.number().or(z.null()),
            local_guide: z.boolean(),
            profile_name: z.string(),
            profile_url: z.string(),
            review_url: z.string(),
            profile_image_url: z.string(),
            owner_answer: z.string().or(z.null()),
            original_owner_answer: z.string().or(z.null()),
            owner_time_ago: z.string().or(z.null()),
            owner_timestamp: z.string().or(z.null()),
            review_id: z.string(),
            images: z.any(),
            review_highlights: z.any(),
        }))),
    }))),
});
export const dataforseoResponseSchema = z.object({
    version: z.string(),
    status_code: z.number(),
    status_message: z.string(),
    time: z.string(),
    cost: z.number(),
    tasks_count: z.number(),
    tasks_error: z.number(),
    tasks: z.array(dataforseoTaskSchema),
});
export const taskItemSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.union([z.literal("ANALYZE_REVIEWS"), z.literal("WINGMAN")]),
    GSI2_SK: z.string(),
    finishedAt: z.string().optional(),
    finishResponse: z
        .object({
        cost: z.number(),
        status_code: z.number(),
        status_message: z.string(),
        time: z.string(),
        result_count: z.number(),
    })
        .optional(),
    params: z.object({
        awardYear: z.number(),
        maxReviews: z.number(),
        placeId: z.string(),
    }),
    startedAt: z.string().optional(),
    status: z.union([
        z.literal("queued"),
        z.literal("running"),
        z.literal("finished"),
    ]),
    submitResponse: z
        .object({
        cost: z.number(),
        status_code: z.number(),
        status_message: z.string(),
        time: z.string(),
    })
        .optional(),
    table: z.string(),
    taskId: z.string().optional(),
    priority: z
        .union([z.literal("high"), z.literal("normal")])
        .default("normal")
        .optional(),
});
//# sourceMappingURL=types.js.map